import script from "./ShoppingCartItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShoppingCartItem.vue?vue&type=script&setup=true&lang=ts"

import "./ShoppingCartItem.vue?vue&type=style&index=0&id=67ea68b0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ea68b0"]])

export default __exports__